import { createSlice } from "@reduxjs/toolkit";
import addRedoReason from "@custom/rtk-apis/redo/addReason";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const addRedoReasonSlice = createSlice({
  name: "addRedoReasonSlice",
  initialState,
  reducers: {
    closeModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addRedoReason.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addRedoReason.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(addRedoReason.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default addRedoReasonSlice.reducer;
export const { closeModal } = addRedoReasonSlice.actions;
